export const _quizId = state => state.quiz.quizId
